<template>
  <div class="breadcrumb-container">
    <div class="back-icon">
      <svg-icon @click="goback" icon="prev"></svg-icon>
    </div>
    <a-breadcrumb>
      <!-- <transition-group name="breadcrumb"> -->
      <a-breadcrumb-item v-for="path in breadPath" :key="path.path">
        <router-link v-if="path.path !== currentPath" :to="path.path">
          {{ generateTitle(path.meta.title) }}
        </router-link>
        <span v-else>{{ generateTitle(path.meta.title) }}</span>
      </a-breadcrumb-item>
      <!-- </transition-group> -->
    </a-breadcrumb>
    <div class="expired" v-if="memberInfo">您的{{ memberInfo.displayLevelText }}在{{ memberInfo.ExpiredTime }}已过期，请及时续费，过期3个月未续将永久关停。</div>
  </div>
</template>
<script lang="ts">
import { useRoute, RouteLocationMatched } from 'vue-router'
import { watch, ref, defineComponent, onMounted } from 'vue'
import { generateTitle } from '@/utils/lang'
import { isNull } from '@/utils/route'
import sysRequest from '@/api/sys'
import dayjs from 'dayjs'
import store from '@/store'
export default defineComponent({
setup(){
  const breadPath = ref<RouteLocationMatched[]>([])
  const route = useRoute()
  breadPath.value = route.matched.filter((r) => !isNull(r.meta))

  const currentPath = ref('')
  const goback = () => {
    window.history.back()
  }
  const memberInfo=ref<any>()
  watch(route, () => {
    breadPath.value = route.matched.filter((r) => !isNull(r.meta))
    currentPath.value = route.path
  })
  onMounted(() => { 
    if(store.getters.userInfo.orgId>1000){
      sysRequest.getMemberInfo(store.getters.userInfo.orgId).then(res=>{
        if(res.data && res.data.length>0 && res.data[0].levelExpired<new Date().getTime()){
        res.data[0].ExpiredTime=dayjs(res.data[0].levelExpired).format("YYYY年MM月DD日")
        memberInfo.value=res.data[0]
        }
      })
    }
    
  })
  return {
    generateTitle,currentPath,breadPath,goback,memberInfo
  }
}
})

</script>
<style lang="scss" scoped>
.breadcrumb-container {
  display:flex;
  align-items:center;
  .back-icon{
    cursor: pointer;
    width:25px;
    height:30px;
    transition: background 0.5s;
    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }
  .ant-breadcrumb{
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
  }
  .expired{
    margin-left:40px;
    width:450px;
    background:rgba(orange,0.4);
    border-radius: 5px;
    padding:5px;
    font-size:12px;
    color:red;
  }
}
</style>
